import React from "react"
import { ButtonRow, BorderRow } from "../../../designSystem/button/ButtonRow";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { SelectField } from "../../../designSystem/formField/SelectField";
import { Icon, IconSize, IconSizes, iconNames, iconName } from "../../../designSystem/icons/Icons";
import { H2 } from "../../../designSystem/typography/Heading";
import { colors } from "../../../designSystem/colors/color";


export const IconOverview = (): JSX.Element => {
    return (
        <>        
            <ButtonRow variant={"left-aligned"}>
                <H2>Icon</H2>
            </ButtonRow>
            <BorderRow>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.active} />
                    <span>active</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.default} />
                    <span>default</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.disabled} />
                    <span>disabled</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.error} />
                    <span>error</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.info} />
                    <span>info</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.passive} />
                    <span>passive</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.pending} />
                    <span>pending</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.success} />
                    <span>success</span>
                </Flex>
                <Flex>
                    <Icon name="facility_kitchen" color={colors.icon.warning} />
                    <span>warning</span>
                </Flex>

            </BorderRow>
                
            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"heart_heartOutlined"}><Icon sizeOverride={8} name={"heart_heartOutlined"} /></span>
                    <span title={"heart_heartFilled"}><Icon sizeOverride={16} name={"heart_heartFilled"} /></span>
                    <span title={"star_starOutlined"}><Icon size="large" name={"star_starOutlined"} /></span>
                    <span title={"star_starFilled"}><Icon size="large" sizeOverride={16} name={"star_starFilled"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"heart_heartOutlined"}><Icon name={"heart_heartOutlined"} /></span>
                    <span title={"heart_heartFilled"}><Icon name={"heart_heartFilled"} /></span>
                    <span title={"star_starOutlined"}><Icon name={"star_starOutlined"} /></span>
                    <span title={"star_starFilled"}><Icon name={"star_starFilled"} /></span>
                </ButtonRow>
            </BorderRow>
            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"actions_close"}><Icon name={"actions_close"} /></span>
                    <span title={"actions_done"}><Icon name={"actions_done"} /></span>
                    <span title={"actions_unavailable"}><Icon name={"actions_unavailable"} /></span>
                    <span title={"actions_plus"}><Icon name={"actions_plus"} /></span>
                    <span title={"actions_minus"}><Icon name={"actions_minus"} /></span>
                    <span title={"add_circle"}><Icon name={"add_circle"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"arrows_chevron_chevronBack"}><Icon name={"arrows_chevron_chevronBack"} /></span>   
                    <span title={"arrows_chevron_chevronUp"}><Icon name={"arrows_chevron_chevronUp"} /></span>
                    <span title={"arrows_chevron_chevronDown"}><Icon name={"arrows_chevron_chevronDown"} /></span>
                    <span title={"arrows_chevron_chevronForward"}><Icon name={"arrows_chevron_chevronForward"} /></span>
                    <span title={"keyboard_double_arrowLeft"}><Icon name={"keyboard_double_arrowLeft"} /></span>
                    <span title={"keyboard_double_arrowRight"}><Icon name={"keyboard_double_arrowRight"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"arrows_arrow_arrowBack"}><Icon name={"arrows_arrow_arrowBack"} /></span>
                    <span title={"arrows_arrow_arrowUp"}><Icon name={"arrows_arrow_arrowUp"} /></span>
                    <span title={"arrows_arrow_arrowDown"}><Icon name={"arrows_arrow_arrowDown"} /></span>
                    <span title={"arrows_arrow_arrowForward"}><Icon name={"arrows_arrow_arrowForward"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"caret_caretBack"}><Icon name={"caret_caretBack"} /></span>
                    <span title={"caret_caretUp"}><Icon name={"caret_caretUp"} /></span>
                    <span title={"caret_caretDown"}><Icon name={"caret_caretDown"} /></span>
                    <span title={"caret_caretForward"}><Icon name={"caret_caretForward"} /></span>
                    <span title={"caret_selector"}><Icon name={"caret_selector"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                <span title={"arrows_actions_fullscreen"}><Icon name={"arrows_actions_fullscreen"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"data_sorting_alphabeticalAscending"}><Icon name={"data_sorting_alphabeticalAscending"} /></span>
                    <span title={"data_sorting_alphabeticalDescending"}><Icon name={"data_sorting_alphabeticalDescending"} /></span>
                    <span title={"data_sorting_numericAscending"}><Icon name={"data_sorting_numericAscending"} /></span>
                    <span title={"data_sorting_numericDescending"}><Icon name={"data_sorting_numericDescending"} /></span>
                    <span title={"data_sorting_sizeAscending"}><Icon name={"data_sorting_sizeAscending"} /></span>
                    <span title={"data_sorting_sizeDescending"}><Icon name={"data_sorting_sizeDescending"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"data_charts_chart"}><Icon name={"data_charts_chart"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"data_files_folderClosed"}><Icon name={"data_files_folderClosed"} /></span>
                    <span title={"data_files_folderOpen"}><Icon name={"data_files_folderOpen"} /></span>
                    <span title={"data_files_file"}><Icon name={"data_files_file"} /></span>
                    <span title={"data_files_document"}><Icon name={"data_files_document"} /></span>
                    <span title={"fact_check"}><Icon name={"fact_check"} /></span>
                    <span title={"fact_check_thin"}><Icon name={"fact_check_thin"} /></span>
                    <span title={"assignment_late"}><Icon name={"assignment_late"} /></span>
                    <span title={"frame_inspect"}><Icon name={"frame_inspect"} /></span>
                    <span title={"list"}><Icon name={"list"} /></span>
                </ButtonRow>
            </BorderRow>


            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"interface_actions_edit"}><Icon name={"interface_actions_edit"} /></span>
                    <span title={"interface_actions_delete"}><Icon name={"interface_actions_delete"} /></span>
                    <span title={"interface_actions_synchronize"}><Icon name={"interface_actions_synchronize"} /></span>
                    <span title={"interface_actions_attach"}><Icon name={"interface_actions_attach"} /></span>
                    <span title={"interface_actions_externalLink"}><Icon name={"interface_actions_externalLink"} /></span>
                    <span title={"interface_actions_copy"}><Icon name={"interface_actions_copy"} /></span>
                    <span title={"interface_actions_bookmark"}><Icon name={"interface_actions_bookmark"} /></span>
                    <span title={"interface_actions_synchronize"}><Icon name={"interface_actions_mail"} /></span>
                    <span title={"interface_actions_notificationOn"}><Icon name={"interface_actions_notificationOn"} /></span>
                    <span title={"interface_actions_notificationOff"}><Icon name={"interface_actions_notificationOff"} /></span>
                    <span title={"interface_actions_view"}><Icon name={"interface_actions_view"} /></span>
                    <span title={"interface_actions_hidden"}><Icon name={"interface_actions_hidden"} /></span>
                    
                    <span title={"interface_actions_filter"}><Icon name={"interface_actions_filter"} /></span>
                    <span title={"interface_actions_share"}><Icon name={"interface_actions_share"} /></span>
                    <span title={"interface_actions_search"}><Icon name={"interface_actions_search"} /></span>
                    <span title={"interface_actions_send"}><Icon name={"interface_actions_send"} /></span>
                    <span title={"interface_actions_save"}><Icon name={"interface_actions_save"} /></span>
                    <span title={"interface_actions_download"}><Icon name={"interface_actions_download"} /></span>
                    <span title={"interface_actions_link"}><Icon name={"interface_actions_link"} /></span>
                    <span title={"interface_actions_linkBreak"}><Icon name={"interface_actions_linkBreak"} /></span>
                    <span title={"interface_actions_like"}><Icon name={"interface_actions_like"} /></span>
                    <span title={"interface_actions_dislike"}><Icon name={"interface_actions_dislike"} /></span>
                    <span title={"interface_actions_print"}><Icon name={"interface_actions_print"} /></span>
                    <span title={"lock"}><Icon name={"lock"} /></span>
                    <span title={"lock_open"}><Icon name={"lock_open"} /></span>

                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"interface_user_user"}><Icon name={"interface_user_user"} /></span>
                    <span title={"interface_user_addUser"}><Icon name={"interface_user_addUser"} /></span>
                    <span title={"interface_user_account"}><Icon name={"interface_user_account"} /></span>
                    <span title={"interface_user_users"}><Icon name={"interface_user_users"} /></span>
                    <span title={"interface_user_team"}><Icon name={"interface_user_team"} /></span>
                    <span title={"interface_user_userOK"}><Icon name={"interface_user_userOK"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"navigation_menu"}><Icon name={"navigation_menu"} /></span>
                    <span title={"navigation_settings"}><Icon name={"navigation_settings"} /></span>
                    <span title={"navigation_map"}><Icon name={"navigation_map"} /></span>
                    <span title={"navigation_home"}><Icon name={"navigation_home"} /></span>
                    <span title={"navigation_homeSelected"}><Icon name={"navigation_homeSelected"} /></span>
                    <span title={"navigation_preferences"}><Icon name={"navigation_preferences"} /></span>
                    <span title={"navigation_calendar"}><Icon name={"navigation_calendar"} /></span>
                    <span title={"navigation_newCalendar"}><Icon name={"navigation_newCalendar"} /></span>
                    <span title={"navigation_inbox"}><Icon name={"navigation_inbox"} /></span>
                    <span title={"navigation_context"}><Icon name={"navigation_context"} /></span>
                    <span title={"navigation_clock"}><Icon name={"navigation_clock"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"interface_glyph_phone"}><Icon name={"interface_glyph_phone"} /></span>
                    <span title={"interface_glyph_comment"}><Icon name={"interface_glyph_comment"} /></span>
                    <span title={"interface_glyph_location"}><Icon name={"interface_glyph_location"} /></span>
                    <span title={"interface_glyph_location_chip"}><Icon name={"interface_glyph_location_chip"} /></span>
                    <span title={"interface_glyph_checked"}><Icon name={"interface_glyph_checked"} /></span>
                    <span title={"interface_glyph_hourglass"}><Icon name={"interface_glyph_hourglass"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"login"}><Icon name={"login"} /></span>
                    <span title={"logout"}><Icon name={"logout"} /></span>
                </ButtonRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"help"}><Icon name={'help'} /></span>
                    <span title={"status_error"}><Icon name={"status_error"} /></span>
                    <span title={"priority"}><Icon name={'priority'} /></span>
                    <span title={"photo_library"}><Icon name={"photo_library"} /></span>
                    <span title={"photo_library_thin"}><Icon name={"photo_library_thin"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"tags_tags"}><Icon name={"tags_tags"} /></span>
                    <span title={"tags_tag"}><Icon name={"tags_tag"} /></span>
                    <span title={"tags_newTag"}><Icon name={"tags_newTag"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"survey_mood_veryBad"}><Icon name={"survey_mood_veryBad"} /></span>
                    <span title={"survey_mood_bad"}><Icon name={"survey_mood_bad"} /></span>
                    <span title={"survey_mood_neutral"}><Icon name={"survey_mood_neutral"} /></span>
                    <span title={"survey_mood_good"}><Icon name={"survey_mood_good"} /></span>
                    <span title={"survey_mood_veryGood"}><Icon name={"survey_mood_veryGood"} /></span>
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"survey_question"}><Icon name={"survey_question"} /></span>
                    <span title={"survey_indicator"}><Icon name={"survey_indicator"} /></span>
                    
                </ButtonRow>
            </BorderRow>


            <BorderRow>
                <ButtonRow variant={"left-aligned"}>
                    <span title={"facility_bathRoom"}><Icon name={"facility_bathRoom"} /></span>
                    <span title={"facility_canteen"}><Icon name={"facility_canteen"} /></span>
                    <span title={"facility_cleaningRoom"}><Icon name={"facility_cleaningRoom"} /></span>
                    <span title={"facility_cloakRoom"}><Icon name={"facility_cloakRoom"} /></span>
                    <span title={"facility_entertainment"}><Icon name={"facility_entertainment"} /></span>
                    <span title={"facility_gym"}><Icon name={"facility_gym"} /></span>
                    <span title={"facility_hallway"}><Icon name={"facility_hallway"} /></span>
                    <span title={"facility_kitchen"}><Icon name={"facility_kitchen"} /></span>
                    <span title={"facility_kitchenette"}><Icon name={"facility_kitchenette"} /></span>
                    <span title={"facility_meetingRoom"}><Icon name={"facility_meetingRoom"} /></span>
                    <span title={"facility_other"}><Icon name={"facility_other"} /></span>
                    <span title={"facility_physicalTherapy"}><Icon name={"facility_physicalTherapy"} /></span>
                    <span title={"facility_reception"}><Icon name={"facility_reception"} /></span>
                    <span title={"facility_relaxationRoom"}><Icon name={"facility_relaxationRoom"} /></span>
                    <span title={"facility_restRoom"}><Icon name={"facility_restRoom"} /></span>
                    <span title={"facility_serverRoom"}><Icon name={"facility_serverRoom"} /></span>
                    <span title={"facility_storageRoom"}><Icon name={"facility_storageRoom"} /></span>

                    <span title={"facility_stairs"}><Icon name={"facility_stairs"} /></span>
                    <span title={"facility_elevator"}><Icon name={"facility_elevator"} /></span>
                    <span title={"facility_production"}><Icon name={"facility_production"} /></span>
                    <span title={"facility_boiler_room"}><Icon name={"facility_boiler_room"} /></span>
                    <span title={"facility_heat_exchanger_room"}><Icon name={"facility_heat_exchanger_room"} /></span>
                    
                </ButtonRow>
            </BorderRow>

            <BorderRow>
                <SvgDemo />
            </BorderRow>
            
        </>
    )
}


function SvgDemo():JSX.Element
{
    const colors = ['white', 'black', 'gray', 'red', 'yellow', 'green', 'blue' ];

    const [settings, setSettings] = React.useState<{
        size:IconSize,
        backgroundColor:string,
        iconColor:string
    }>({size:'small', backgroundColor:'gray', iconColor:'yellow' });

    return (
        <Flex gap={16} flexDirection="column">
            <Flex gap={16}>
                <SelectField 
                    selectedValue={settings.iconColor} 
                    options={colors.map(c => { return {text:c, value:c}})} 
                    onChange={value => setSettings({...settings, iconColor:value})} 
                    label={"Color"}
                />
                <SelectField 
                    selectedValue={settings.backgroundColor} 
                    options={colors.map(c => { return {text:c, value:c}})} 
                    onChange={value => setSettings({...settings, backgroundColor:value})} 
                    label={"Background"}
                />
                <SelectField 
                    selectedValue={settings.size} 
                    options={IconSizes.map(s => { return {text:s, value:s}})} 
                    onChange={value => setSettings({...settings, size:value as IconSize})} 
                    label={"Size"}
                />
            </Flex>
            <div style={{display:'flex', gap:'10px', marginBottom:'10px', alignItems:'center', flexWrap:'wrap'}}>
                {iconNames.map(i => 
                    <SvgDemoIcon key={i} {...settings} icon={i} />
                )}
            </div>
        </Flex>
    );
}

type SvgDemoProps = {
    icon:iconName,
    size:IconSize,
    backgroundColor:string,
    iconColor:string
}
function SvgDemoIcon(props:SvgDemoProps):JSX.Element
{
    return (
        <span style={{padding:'10px', outline:'1px dotted #ccc', backgroundColor:props.backgroundColor}} title={props.icon}>
            <Icon name={props.icon} color={props.iconColor} size={props.size} />
        </span>
    );
}